import React from 'react';

export const NotFoundPage = React.memo(() => (
  <h1 role="banner">Page Not Found</h1>
));
